import {ENV_CONFIGS, ISSUES_REGIONS} from '../constants/envs';

export const getRegion = () => ENV_CONFIGS.REGION;

export const isFedrampRegion = () => getRegion() === ISSUES_REGIONS.FEDRAMP;
